import { NAME_DEV_SET } from "../../../../function/NameDevSetModel";
import dayjs from "dayjs";

/**
 * IoTBox設定Type
 */
export type IOT_SET = {
  /** IMSI No.*/
  IMSI_NO: string;
  /** 機器INDEX*/
  DEV_INDEX: number;
  /** 自動収集フラグ*/
  RUN_FLG: string;
  /** 自動収集開始時刻 秒*/
  LOG_SEC: string;
  /** 自動収集開始時刻 分*/
  LOG_MIN: string;
  /** 自動収集開始時刻 時*/
  LOG_HOUR: string;
  /** 自動収集開始時刻 日*/
  LOG_DAY: string;
  /** 自動収集開始時刻 月*/
  LOG_MONTH: string;
  /** 自動収集開始時刻 曜日*/
  LOG_DOW: string;
  /** 産業用バッテリ寿命*/
  MOBILE_BATTERY?: number;
  /** リチウムバッテリ寿命*/
  LITHIUM_BATTERY?: number;
  /** 最新収集日時*/
  LOG_NEW?: Date;
  /** 次回収集日時*/
  LOG_NEXT?: Date;
  /** 設定バージョン*/
  SET_VER: string;
  /** 収集状態フラグ*/
  GET_FLG?: number;
  /** 設定状態フラグ*/
  IOT_SET_FLG?: number;
  /** 学習モードフラグ*/
  STUDY_FLG?: number;
  /** 学習モード設定*/
  STUDY_SET?: number;
  /** メモ*/
  MEMO: string;
  /** PLCNo.*/
  PLC_NO: number;
  /** ヘルシー最新収集日時*/
  HEALTH_NEW?: Date;
  /** ヘルシー次回収集日時*/
  HEALTH_NEXT?: Date;
  /** エラーログ最新収集日時*/
  ERRORLOG_NEW?: Date;
  /** エラーログ次回収集日時*/
  ERRORLOG_NEXT?: Date;
  /** IotBoxエラーログ エラーコード*/
  ERROR_CODE?: string
  /** ヘルシーチェック収集状態フラグ*/
  HEALTH_FLG?: number;
  /** エラーログ状態フラグ*/
  ERRORLOG_FLG?: number;
  /** ヘルスチェック　エラーコード*/
  HEALTH_CODE: string;
  /** ヘルシーチェック異常区分 */
  ALM_KIND: number;
  STUDY_NEW?: Date;
  STUDY_NEXT?: Date;
  STUDY_COUNT?: number;
  STUDY_STATUS?: number;
};


/**
 * IoTBox設定 画面(編集)項目
 */
export type V_IOTBOX_SETTING_ITEM = {
  /** IMSI No.*/
  IMSI_NO: string;
  /** 自動収集フラグ*/
  RUN_FLG: string;
  /** 機器INDEX*/
  DEV_INDEX: number;
  DEV_NO: string;
  DEV_NAME: string;
  /** 自動収集開始時刻 秒*/
  LOG_SEC: string;
  /** 自動収集開始時刻 分*/
  LOG_MIN: string;
  /** 自動収集開始時刻 時*/
  LOG_HOUR: string;
  /** 産業用バッテリ寿命(最大使用日数)*/
  MOBILE_BATTERY?: number;
  /** リチウムバッテリ寿命(最大使用日数)*/
  LITHIUM_BATTERY?: number;
  /** 設定バージョン*/
  SET_VER: string;
  /** 設定状態フラグ TODO 設定ファイルDLボタンと値は併用。完了＝DL完了、編集不可＝DL未実施？*/
  IOT_SET_FLG?: number;
  /** PLCNo.*/
  PLC_NO: number;
  IOT_SET?: IOT_SET;
  /**機器番号・機器名称*/
  NAME_DEV_SET?: NAME_DEV_SET;
  /**リチウムバッテリ現在電圧値*/
  LITHIUM_VOLT: number,
  /**モバイルバッテリ現在電圧値*/
  MOBILE_VOLT: number,
  /**リチウム交換日時*/
  LITHIUM_CHANGE_DAYTIME?: Date,


  /** 設定ファイルDL 可能フラグ*/
  DL_ENABLE: boolean;
  /** 設定状態フラグ表示文字*/
  IOT_SET_FLG_Disp: string;
  /** 設定ファイルDL ボタン表示文字*/
  DL_Disp: string;
  /**モバイルバッテリ残量パーセント変換文字*/
  mobileVoltLevel: string,
  /**リチウムバッテリ残日数文字
   * 残日数＝最大使用日数－(現在日時ー交換日時)
   */
  lithiumVoltRemainingDays: string,

  //リスト編集フラグ
  IS_EDITED?: boolean;
}

/**
 * バッテリー残量変換設定
 */
export type BATTERY_CONVERT_SET = {
  /**電圧レベル区分 1:7.2V(産業用バッテリの出力電圧のモニタ値)、2:3.6V(塩化チオニルリチウムバッテリの出力電圧のモニタ値) */
  VOLT_INDEX: number;
  /**下限電圧(V)*/
  LOWER_VOLT: number;
  /**上限限電圧(V)*/
  UPPER_VOLT: number;
  /**残量パーセント(%)*/
  BATTERY_PERCENT: number;
}

export type IoTBoxSettingType = {
  V_IOTBOX_SETTING_ITEMS: V_IOTBOX_SETTING_ITEM[];
}

/**
 * APIレスポンスコード
 */
export const ApiResponseCode = {
  DEFAULT: 200,
  SUCCESS: 204,         //新規登録要求待ちレコード追加
  BAD_REQUEST: 400,     //パラメータ異常
  NOT_ACCEPTABLE: 406,  //状態チェック
  DevIndexConanRegistered: 412,  //コナンエアー管理側で登録済みの機器Index
  PLC_NO_FULL_ERROR: 413, //TMBee-Boxで登録できるPLC_NOに空き番が存在しない
  UPDATE_FAILURE: 500,  //更新失敗
  SERVICE_UNAVAILABLE: 503,  //ネットワーク接続失敗
} as const;
type ApiResponseCode = typeof ApiResponseCode[keyof typeof ApiResponseCode];


/**
 * IoTBox設定一覧取得
 * @returns
 */
export const GetIoTBoxSettingLists = (): Promise<IoTBoxSettingType> => {
  return new Promise((resolve, reject) => {
    const url = 'api/IoTBoxSetting?';
    var param = "";
    console.debug(`${url}${param}`);
    fetch(`${url}${param}`)
      .then((res) => res.json())
      .then((result: IoTBoxSettingType) => {
        console.debug(['result', result]);
        if (IoTBoxSettingTypeValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const IoTBoxSettingTypeValidate = (data: IoTBoxSettingType) => {
  console.debug(`IoTBoxSetting ckeck ${data}`);
  if (data == undefined) return false;

  // if (data.V_IOTBOX_SETTING_ITEMS == undefined || data.V_IOTBOX_SETTING_ITEMS.length == 0) {
  //   data.V_IOTBOX_SETTING_ITEMS = new Array(createDefaltIoTBoxSetting());
  // }
  console.debug("IoTBoxSetting ckeck ok");
  return true;
};


/**
 * バッテリー残量変換設定リスト取得
 * API呼出　api/BatteryConvertSet
 * @returns BATTERY_CONVERT_SET[]
 */
export const GetBatteryConvertSet = (): Promise<BATTERY_CONVERT_SET[]> => {
  return new Promise((resolve, reject) => {
    const url = 'api/BatteryConvertSet?';
    var param = "";
    console.debug(`${url}${param}`);
    fetch(`${url}${param}`)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: BATTERY_CONVERT_SET[]) => {
        console.debug(['result', result]);
        resolve(result);
      }).catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};


/**
 *  バッテリ交換押下時の日時を登録する。
 *  API呼出　api/lithiumChagenDayTime
 * @param imsiNo 更新対象のimsiNo
 * @returns 更新結果　正常時 204
 */
export const PutLithiumChagenDayTime = (imsiNo: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    const url = 'api/IoTBoxSetting/lithiumChagenDayTime';
    fetch(url, {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imsiNo),
    })
      .then(res => {
        console.debug(['res', res]);
        resolve(res.status)
      })
      .catch(error => {
        console.debug(['error', error]);
        reject(error)
      });
  });
};


/**
 * IoTSet 新規登録
 * @param data
 * @returns statusCode
 */
export const InsertIoTSet = (data: IOT_SET): Promise<number> => {
  console.debug(['InsertIoTSet', data]);

  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting', {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(res => {
        console.debug(['res', res]);
        resolve(res.status)
      })
      .catch(reason => {
        console.debug(['reason', reason]);
        reject(reason)
      });
  });
}

/**
 * IoTSet 削除
 * @param imsiNo
 * @returns
 */
export const deleteIoTSet = (imsiNo: string): Promise<number> => {
  console.debug(['deleteIoTSet', imsiNo]);

  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting', {
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(imsiNo),
    })
      .then(res => {
        console.debug(['res', res]);
        resolve(res.status)
      })
      .catch(reason => {
        console.debug(['reason', reason]);
        reject(reason)
      });
  });
}

/**
 * IoTSet を変更
 * @param data
 * @returns
 */
export const SetIoTSetType = (data: V_IOTBOX_SETTING_ITEM): Promise<number> => {
  console.debug(['SetIoTSetType', data]);

  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting', {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(res => {
        console.debug(['res', res]);
        resolve(res.status);
      })
      .catch(reason => {
        console.debug(['reason', reason]);
        reject(reason)
      });
  });
}

/**
 * IoTSet を変更
 * @param list
 * @returns
 */
export const SetIoTSetListType = (list: V_IOTBOX_SETTING_ITEM[]): Promise<number> => {
  console.debug(['SetIoTSetListType', list]);

  return new Promise((resolve, reject) => {
    fetch('api/IoTBoxSetting/IotSetList', {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(list),
    })
      .then(res => {
        console.debug(['res', res]);
        resolve(res.status);
      })
      .catch(reason => {
        console.debug(['reason', reason]);
        reject(reason)
      });
  });
}

/**
 * 産業用バッテリの現在の電圧値より、変換テーブルを使用して残量(%)を取得(モバイル)
 * @param target　コンバート対象データ
 * @param convertList　コンバート用の配列
 * @returns バッテリー残量（％）
 */
export const GetMobileBatteryLevel = (target: V_IOTBOX_SETTING_ITEM, convertList: BATTERY_CONVERT_SET[]): string => {

  if (target == null || convertList == null) {
    return "0.0";
  }

  if (convertList.length === 0) {
    return "0.0";
  }

  const rowIndex = convertList.findIndex(
    //r.VOLT_INDEX == 1でモバイル用
    (r) => r.VOLT_INDEX == 1 && r.LOWER_VOLT <= target.MOBILE_VOLT && target.MOBILE_VOLT < r.UPPER_VOLT);

  if (rowIndex === -1) {
    return "0.0";
  }

  console.debug(["target.MOBILE_VOLT,convertList[rowIndex]", target.MOBILE_VOLT, convertList[rowIndex]])
  //電池残量を計算
  //範囲内の％＋１０＊(測定電圧－下限電圧)/(上限電圧ー下限電圧)＝残量(％)
  let batteryPer: number = convertList[rowIndex].BATTERY_PERCENT
    + 10 * (target.MOBILE_VOLT - convertList[rowIndex].LOWER_VOLT)
    / (convertList[rowIndex].UPPER_VOLT - convertList[rowIndex].LOWER_VOLT);

  console.debug(["batteryPer", batteryPer])
  if (batteryPer > 100) {
    batteryPer = 100;
  }
  return batteryPer.toFixed(1);
}
/**
 * リチウムバッテリの残り日数を計算して取得
 * @param target　コンバート対象データ
 * @returns バッテリー残量（％）
 */
export const GetLithiumVoltRemainingDays = (target: V_IOTBOX_SETTING_ITEM): string => {

  if (target == null) {
    return "--";
  }
  if (target.LITHIUM_CHANGE_DAYTIME == null) {
    return "0";
  }
  if (target.LITHIUM_BATTERY == null) {
    return "--";
  }

  //バッテリー変更日数
  const changeDate = dayjs(target.LITHIUM_CHANGE_DAYTIME);
  //現在日時
  const nowDate = dayjs();
  //経過日数　-〇日
  const passDay = nowDate.diff(changeDate, 'day', false);
  //残り日数
  let daysLeft = target.LITHIUM_BATTERY - passDay;
  if (daysLeft < 0) {
    daysLeft = 0;
  }

  return daysLeft.toString();
}
